import { render, staticRenderFns } from "./main.vue?vue&type=template&id=b1e120c6&scoped=true&functional=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=b1e120c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "b1e120c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1e120c6')) {
      api.createRecord('b1e120c6', component.options)
    } else {
      api.rerender('b1e120c6', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=b1e120c6&scoped=true&functional=true&", function () {
      api.rerender('b1e120c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DwDivider/src/main.vue"
export default component.exports